<template>
  <div class="py-5 px-2 lg:-mx-1 mt-4">
    <div v-html="page.content"></div>
    <div v-if="!page.content.length && !page.active">
      <span class="text-2xl font-bold text-title mr-3">404</span>Sivua ei löydy.
      Tarkista osoite.
    </div>
  </div>
</template>

<script setup lang="ts">
import Page from "@/interfaces/Page";

defineProps<{ page: Page }>();
</script>
